export default "__VITE_ASSET__CcYHmavL__"